export enum ItemSizeType {
  NoPackage = "NoPackage",
  SmallPackage = "SmallPackage",
  MediumPackage = "MediumPackage",
  BigPackage = "BigPackage",
  SpecialPackage = "SpecialPackage",
  FrozenPackage = "FrozenPackage",
  CooledPackage = "CooledPackage",
  BasePack = "BasePack",
  Extras = "Extras",
  Pallet = "Pallet",
  Other = "Other",
  Multi = "Multiple",
  Custom1 = "Custom1",
  Custom2 = "Custom2",
  Custom3 = "Custom3",
  Custom4 = "Custom4",
  Custom5 = "Custom5",
  Custom6 = "Custom6",
  Custom7 = "Custom7",
  Custom8 = "Custom8",
  Custom9 = "Custom9",
  Custom10 = "Custom10",
  Custom11 = "Custom11",
  Custom12 = "Custom12",
  Custom13 = "Custom13",
  Custom14 = "Custom14",
  Custom15 = "Custom15",
  Custom16 = "Custom16",
  Custom17 = "Custom17",
  Custom18 = "Custom18",
  Custom19 = "Custom19",
  Custom20 = "Custom20",
  Custom21 = "Custom21",
  Custom22 = "Custom22",
  Custom23 = "Custom23",
  Custom24 = "Custom24",
  Custom25 = "Custom25",
  Custom26 = "Custom26",
  Custom27 = "Custom27",
  Custom28 = "Custom28",
  Custom29 = "Custom29",
  Custom30 = "Custom30",
  Custom31 = "Custom31",
  Custom32 = "Custom32",
  Custom33 = "Custom33",
  Custom34 = "Custom34",
  Custom35 = "Custom35",
  Custom36 = "Custom36",
  Custom37 = "Custom37",
  Custom38 = "Custom38",
  Custom39 = "Custom39",
  Custom40 = "Custom40",
  Custom41 = "Custom41",
  Custom42 = "Custom42",
  Custom43 = "Custom43",
  Custom44 = "Custom44",
  Custom45 = "Custom45",
  Custom46 = "Custom46",
  Custom47 = "Custom47",
  Custom48 = "Custom48",
  Custom49 = "Custom49",
  Custom50 = "Custom50",
  Custom51 = "Custom51",
  Custom52 = "Custom52",
  Custom53 = "Custom53",
  Custom54 = "Custom54",
  Custom55 = "Custom55",
  Custom56 = "Custom56",
  Custom57 = "Custom57",
  Custom58 = "Custom58",
  Custom59 = "Custom59",
  Custom60 = "Custom60",
  Custom61 = "Custom61",
  Custom62 = "Custom62",
  Custom63 = "Custom63",
  Custom64 = "Custom64",
  Custom65 = "Custom65",
  Custom66 = "Custom66",
  Custom67 = "Custom67",
  Custom68 = "Custom68",
  Custom69 = "Custom69",
  Custom70 = "Custom70",
}
